import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tab"
export default class extends Controller {
  connect() {
    this.element.addEventListener("click", (event)=>{
      event.preventDefault()
    }
    )
  }
}
